import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-pastel-gradient">
      <div className="container-pastel px-4 py-12">
        <Link
          to="/"
          className="inline-flex items-center text-gray-600 hover:text-gray-900 mb-8 font-poppins"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to Home
        </Link>

        <div className="card-pastel p-8">
          <h1 className="text-3xl font-bold text-gray-800 mb-8 font-poppins">Privacy Policy</h1>

          <div className="max-w-none text-gray-700">
            <p className="text-sm text-gray-500 mb-6 font-poppins">Last updated: {new Date().toLocaleDateString()}</p>

            <div className="bg-white/60 p-6 rounded-lg mb-8">
              <h2 className="text-xl font-semibold mb-4 text-gray-800 font-poppins">Table of Contents</h2>
              <ol className="list-decimal list-inside space-y-2 font-poppins text-gray-600">
                <li><a href="#information-collect" className="hover:text-pastel-purple-600">Information We Collect</a></li>
                <li><a href="#information-use" className="hover:text-pastel-purple-600">How We Use Your Information</a></li>
                <li><a href="#information-sharing" className="hover:text-pastel-purple-600">Information Sharing</a></li>
                <li><a href="#data-security" className="hover:text-pastel-purple-600">Data Security</a></li>
                <li><a href="#your-rights" className="hover:text-pastel-purple-600">Your Rights</a></li>
                <li><a href="#contact-us" className="hover:text-pastel-purple-600">Contact Us</a></li>
              </ol>
            </div>

            <section id="information-collect" className="mb-8">
              <h2 className="text-2xl font-bold mb-4 text-gray-800 font-poppins">1. Information We Collect</h2>
              <p className="mb-4 font-poppins">We collect information you provide directly to us when you:</p>
              <ul className="list-disc list-inside space-y-2 ml-4 font-poppins text-gray-600">
                <li>Create an account</li>
                <li>Create or modify a registry</li>
                <li>Make a purchase or contribution</li>
                <li>Contact us for support</li>
              </ul>
            </section>

            <section id="information-use" className="mb-8">
              <h2 className="text-2xl font-bold mb-4 text-gray-800 font-poppins">2. How We Use Your Information</h2>
              <p className="mb-4 font-poppins">We use the information we collect to:</p>
              <ul className="list-disc list-inside space-y-2 ml-4 font-poppins text-gray-600">
                <li>Provide and maintain our services</li>
                <li>Process your transactions</li>
                <li>Send you notifications and updates</li>
                <li>Improve our services</li>
              </ul>
            </section>

            <section id="information-sharing" className="mb-8">
              <h2 className="text-2xl font-bold mb-4 text-gray-800 font-poppins">3. Information Sharing</h2>
              <p className="mb-4 font-poppins">We do not sell or rent your personal information to third parties. We may share your information only in the following circumstances:</p>
              <ul className="list-disc list-inside space-y-2 ml-4 font-poppins text-gray-600">
                <li>With your consent</li>
                <li>To comply with legal obligations</li>
                <li>To protect our rights and safety</li>
              </ul>
            </section>

            <section id="data-security" className="mb-8">
              <h2 className="text-2xl font-bold mb-4 text-gray-800 font-poppins">4. Data Security</h2>
              <p className="mb-4 font-poppins">We implement appropriate security measures to protect your personal information. However, no method of transmission over the Internet is 100% secure.</p>
            </section>

            <section id="your-rights" className="mb-8">
              <h2 className="text-2xl font-bold mb-4 text-gray-800 font-poppins">5. Your Rights</h2>
              <p className="mb-4 font-poppins">You have the right to:</p>
              <ul className="list-disc list-inside space-y-2 ml-4 font-poppins text-gray-600">
                <li>Access your personal information</li>
                <li>Correct inaccurate information</li>
                <li>Request deletion of your information</li>
                <li>Opt-out of marketing communications</li>
              </ul>
            </section>

            <section id="contact-us" className="mb-8">
              <h2 className="text-2xl font-bold mb-4 text-gray-800 font-poppins">6. Contact Us</h2>
              <p className="mb-2 font-poppins">If you have questions about this Privacy Policy, please contact us at:</p>
              <p className="mb-1 font-poppins"><strong>Email:</strong> privacy@giftyfy.com</p>
              <p className="font-poppins"><strong>Phone:</strong> +94 779257975</p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
